import { useLookbookContext } from '@app/components/lookbook/context/LookbookContext';
import { usePageProductsContext } from '@app/components/pages/context/PageProductsContext';
import { useLookbookPageProducts } from '@app/services/hooks/lookbook/useLookbookPageProducts';
import { isDefined } from '@app/utils/is';
import { Cms, CmsBlocks } from '@typings';
import React from 'react';
import { useInView } from 'react-intersection-observer';

import { ProductBlock } from './ProductBlock';

export const LookbookProductBlock = (props: CmsBlocks.BlockProps<Cms.ProductBlock>) => {
  const { parameters } = props;
  const [ref, isInView] = useInView({
    rootMargin: '200px 0px',
    triggerOnce: true,
  });
  const { lookbookId } = useLookbookContext();
  const { handleProductsUpdate } = usePageProductsContext();
  const { data: productsData, isLoading } = useLookbookPageProducts({ blocks: [parameters], isEnabled: isInView, lookbookId });

  React.useEffect(() => {
    if (isDefined(productsData)) {
      handleProductsUpdate?.(productsData);
    }
  }, [productsData, handleProductsUpdate]);

  return <ProductBlock productsData={productsData} isLoading={isLoading} {...props} ref={ref} />;
};
